import * as braze from '@braze/web-sdk';
import { ENV } from 'src/environment';
import { config } from './config';

function changeUser(userIdentifier: string) {
  if (ENV === 'development') return;
  braze.changeUser(userIdentifier);
}

function setAnonymousUserAttributes(email: string) {
  if (ENV === 'development') return;
  braze.getUser()?.addAlias('email', email);
}

const hasInitialized = false;
export default (() => {
  if (!hasInitialized) {
    braze.initialize(config.apiKey, {
      baseUrl: config.sdkEndpoint,
      enableLogging: false,
    });
    braze.requestPushPermission();
    // https://www.braze.com/docs/developer_guide/platform_integration_guides/web/initial_sdk_setup/#step-2-initialize-braze
    // braze.automaticallyShowInAppMessages();
    // braze.openSession();
  }
  return {
    changeUser,
    client: braze,
    setAnonymousUserAttributes,
  };
})();
